module.exports = __webpack_public_path__ + "static/media/CeraPro-Light.2b75ffb5.eot";